import { createReducer, on } from '@ngrx/store';
import * as OrderItemTypesActions from './order-item-types.actions';
import { iItemsTypes } from 'src/app/pages/orders/order-taking/components/new-order/models/iItemsTypes.model';

export interface OrderItemTypesState {
  response: iItemsTypes[] | null;
  error: any | null;
  loading: boolean;
  cache?: { [key: string]: iItemsTypes[] };
}

export const initialState: OrderItemTypesState = {
  response: null,
  error: null,
  loading: false,
  cache: {},
};

export const orderItemTypesReducer = createReducer(
  initialState,
  on(OrderItemTypesActions.loadOrderItemTypes, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(OrderItemTypesActions.loadOrderItemTypesSuccess, (state, { response }) => ({
    ...state,
    loading: false,
    response,
    error: null,
  })),
  on(OrderItemTypesActions.loadOrderItemTypesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(OrderItemTypesActions.loadOrderItemTypesSuccessByKey, (state, { key, response }) => ({
    ...state,
    loading: false,
    response,
    cache: { ...(state.cache || {}), [key]: response },
    error: null,
  })),
);
